import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { PrepaidPlan } from 'src/features/subscriptions/types';

const RESOURCE = '/parkings/:parkingId/prepaid-plan/:planId/';

interface DTO {
    parkingId: string;
    planId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, planId, ...params }: DTO): Promise<PrepaidPlan> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, planId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPrepaidPlan };
